import { render, staticRenderFns } from "./CargoManager.vue?vue&type=template&id=3dd7d9e0&scoped=true"
import script from "./CargoManager.vue?vue&type=script&lang=js"
export * from "./CargoManager.vue?vue&type=script&lang=js"
import style0 from "./CargoManager.vue?vue&type=style&index=0&id=3dd7d9e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd7d9e0",
  null
  
)

export default component.exports